import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  BeerType,
  BottomFermented,
  BreweryType,
  CharacterOfBeer,
  Hybrid,
  SpontaneouslyFermented,
  TopFermented,
} from 'src/app/products/interfaces/models';

import { BeerProperties } from '@app/api/models';
import {
  RequiredExceptions,
  SubformBaseWithSugarContentPropertiesComponent,
} from '@products/components/forms/subform-base-with-sugar-content-properties/subform-base-with-sugar-content-properties.component';

@Component({
  selector: 'app-beer-properties-subform',
  templateUrl: './beer-properties-subform.component.html',
  styleUrls: ['./beer-properties-subform.component.scss'],
})
export class BeerPropertiesSubformComponent extends SubformBaseWithSugarContentPropertiesComponent {
  override alcoholic = true;
  static BALLING_VALIDATORS = [
    Validators.min(0),
    Validators.max(100),
    Validators.required,
  ];

  static requiredExceptions: RequiredExceptions = {
    sugarContentType: true,
  };

  DICT_PATH = 'PRODUCTS.BEER_PROPERTIES';

  breweryType = BreweryType;
  beerType = BeerType;
  spontaneouslyFermentedType = SpontaneouslyFermented;
  topFermentedType = TopFermented;
  bottomFermentedType = BottomFermented;
  hybridFermentedType = Hybrid;
  characterOfBeer = CharacterOfBeer;

  static buildForm(
    fb: FormBuilder,
    data: BeerProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    return fb.group({
      breweryType: [data?.breweryType, Validators.required],
      beerType: [data?.beerType, Validators.required],
      ...(data?.beerType == BeerType.SpontaneouslyFermented && {
        spontaneouslyFermentedType: [
          data?.spontaneouslyFermentedType,
          Validators.required,
        ],
      }),
      ...(data?.beerType == BeerType.TopFermented && {
        topFermentedType: [data?.topFermentedType, Validators.required],
      }),

      ...(data?.beerType == BeerType.BottomFermented && {
        bottomFermentedType: [data?.bottomFermentedType, Validators.required],
      }),

      ...(data?.beerType == BeerType.Hybrid && {
        hybridFermentedType: [data?.hybridFermentedType, Validators.required],
      }),

      characterOfBeer: [data?.characterOfBeer, Validators.required],

      ...(!isSecondaryProductSheet && {
        degreeOfBalling: [
          data?.degreeOfBalling,
          BeerPropertiesSubformComponent.BALLING_VALIDATORS,
        ],
      }),

      // build sugar content properties
      ...{
        sugarContentProperties:
          SubformBaseWithSugarContentPropertiesComponent.buildFields(
            data?.sugarContentProperties,
            this.requiredExceptions,
            true,
            fb
          ),
      },
    });
  }

  onTypeSelected(selected: BeerType) {
    this._addOrRemove(
      selected,
      BeerType.SpontaneouslyFermented,
      'spontaneouslyFermentedType'
    );
    this._addOrRemove(selected, BeerType.TopFermented, 'topFermentedType');
    this._addOrRemove(
      selected,
      BeerType.BottomFermented,
      'bottomFermentedType'
    );
    this._addOrRemove(selected, BeerType.Hybrid, 'hybridFermentedType');
  }

  /*
   * add or remove subtypes depending on the selected type
   */
  _addOrRemove(selected: BeerType, target: BeerType, control: string) {
    if (selected === target) {
      this.group.addControl(
        control,
        this.fb.control(null, Validators.required)
      );
    } else {
      this.group.removeControl(control);
    }
  }
}
